import React from 'react';
import PropTypes from 'prop-types';
import Button from 'ui/Button';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Box, Typography } from '@mui/material';
import isMobileDevice from 'utils/mobileAndTabletCheck';

const PageTop = ({ pageInfo, cta, onGoBack, v2 }) => {

  if (!pageInfo) return null;

  const isMobile = isMobileDevice();

  return(
    <>
      { v2 ? (
        <Box sx={{ mb: 3, pt: 3, mt: isMobile ? 6 : 3 }}>
          <Typography variant="h1" sx={{ mb: 1, fontSize: "1.35rem", fontWeight: 700, lineHeight: 1.2 }}>
            { pageInfo["name"] }
          </Typography>
          <Typography variant="subtitle1" sx={{ fontSize: "0.95rem", color: "#6b7280", lineHeight: 1.3 }}>
            { pageInfo["description"] }
          </Typography>
        </Box>

      ) : (

        <div className="page-top">

          <div>

            {onGoBack && 
              <Button text small grey onClick={ onGoBack } icon={ArrowBackOutlinedIcon}>
                Back
              </Button>}
            
            <div className="page-label">{ pageInfo["label"] }</div>
            <div className="page-name">{ pageInfo["name"] }</div>
          </div>

          { pageInfo["description"] &&
            <div className="page-description">{ pageInfo["description"] }</div>
          }

          { pageInfo["action"] && cta }
        </div>
      )}
    </>
  )
};

PageTop.propTypes = {
  pageInfo: PropTypes.object,
  cta: PropTypes.node,
  onGoBack: PropTypes.func,
  v2: PropTypes.bool,
};

export default PageTop;